import React, { useEffect, useRef } from 'react';
import { Slide, toast } from 'react-toastify';
import { isBreakpoint } from 'helpers';
import { NotificationItem } from './NotificationList';
import styles from './styles/MobileNotification.module.scss';
import { useSelector } from 'react-redux';
import { getMarketScanReadyNotifications } from 'selectors';
import { showNotificationByRoute } from 'helpers/notification';

const shouldShowToast = () => {
  return isBreakpoint('md') && showNotificationByRoute();
};

const emitMobileToast = (notification) => {
  toast(
    <NotificationItem
      className={styles.notification}
      key={notification.id}
      period="Today"
      hideNotification={R.F}
      {...notification}
    />,
    {
      className: styles.mobileToast,
      position: 'top-right',
      autoClose: 1000,
      closeOnClick: true,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      transition: Slide,
      style: {
        pointerEvents: 'auto',
      },
    },
  );
};

const MobileNotification = () => {
  const msReadyNotifications = useSelector(getMarketScanReadyNotifications);
  const notificationHistory = useRef(msReadyNotifications);

  useEffect(() => {
    const toEmit = msReadyNotifications.filter(
      (n) => !notificationHistory.current.find(R.propEq('id', n.id)),
    );

    if (toEmit.length) {
      shouldShowToast() && toEmit.forEach(emitMobileToast);
      notificationHistory.current = [...msReadyNotifications];
    }
  }, [msReadyNotifications]);

  return null;
};

export default MobileNotification;
